import { Fragment, useEffect } from 'react'

import { useCurrentUserId } from 'lib/use-current-user-id'
import { useRouter } from 'next/router'

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const GlobalDataset = ({ children }: Props) => {
  const router = useRouter()
  const userId = useCurrentUserId()

  useEffect(() => {
    const dataset = window.document.getElementsByTagName('html')[0].dataset
    dataset.currentPath = router.pathname

    if (Boolean(userId)) {
      dataset.loggedUser = ''
    }
  }, [router, userId])

  return <Fragment>{children}</Fragment>
}

export default GlobalDataset
